/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool } from 'prop-types';
import mbpLogger from 'mbp-logger';
import { Query } from '@apollo/client/react/components';
import findContent from '../../../../../../gql/queries/findContent';
import makeStyles from '@material-ui/styles/makeStyles';
import Link from '@material-ui/core/Link';
import { GRAPHQL_ENV } from '../../../../../../gql';
import GenericSkeleton from '../../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';


const useStyles = (mobile) => makeStyles(() => ({
   mainJokeContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      backgroundColor: '#A6E4EF',
      borderRadius: '8px',
      border: '1px solid #FFFFFF',
      zIndex: '2',
      height: '100%',
      width: '100%',
      maxWidth: '715px',
      padding: '12px',
      overflow: 'hidden',
      textAlign: 'center',
      '& p': {
         marginBottom: '0px',
         fontFamily: 'Lato, sans-serif !important',
      },
      '& .jokeTitle': {
        fontSize: `${mobile ? '16px' : '20px'}!important`,
        fontWeight: 700,
        color: '#0D2142',
        textTransform: 'uppercase',
        paddingBottom: `${mobile ? '2px' : '4px'}`
      },
      '& .joke, .link': {
        fontWeight: 400,
        fontSize: '16px!important',
        color: '#091D3E'
      },
      '& .linkContainer': {
         paddingTop: `${mobile ? '4px' : '8px'}`,
         '& .link': {
            textDecoration: 'underline',
            textDecorationColor: 'inherit',
            fontWeight: 700,
          }
      }
  },
}));

const DadJokeOfTheDay = ({ mobile }) => {
  const classesLayout = useStyles(mobile);
  const classes = classesLayout();
  const skeletons = GenericSkeleton({ height: mobile ? 120 : 100, width: mobile ? 270 : 715, repeatCount: 1 });
  const dadJokePayload = { brand: '1800flowers', environment: GRAPHQL_ENV, contentType: 'dad_joke_gpt' };
  const DAD_JOKE_QUERY = findContent(dadJokePayload);
  return (
   <Query query={DAD_JOKE_QUERY}>
      {({ data, loading, error }) => {

         const dadJokeDataEntry = data?.findContent?.content?.entries?.[0];
         const dadJokeCtaHref = dadJokeDataEntry?.cta_button?.cta_url?.href || 'https://www.harryanddavid.com/blog/best-dad-jokes/';
         const dadJokeCtaTitle = dadJokeDataEntry?.cta_button?.cta_url?.title || 'Check Out More Top Jokes';
         const dadJoke = dadJokeDataEntry?.title || 'How do ghosts stay in shape? They exorcise.';
         const bannerTitle = dadJokeDataEntry?.dad_joke_banner_title || 'Dad Joke Of The Day';

         if (error) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                query: DAD_JOKE_QUERY,
                component: 'DadJokeOfTheDay.js',
                message: 'Error loading joke of the day',
                env: GRAPHQL_ENV,
                error,
            });
            return null;
         };

         return (
            <>
               {loading && skeletons.map(skeleton => skeleton)}
               {!loading && data?.findContent?.content &&
                  <div className={classes.mainJokeContainer}>
                     <p className='jokeTitle'>{bannerTitle}</p>
                     <p className='joke'>{dadJoke}</p>
                     <p className='linkContainer'><Link className='link' href={`${dadJokeCtaHref}`} aria-label="website with the best dad jokes" target="_blank" rel="noopener">{dadJokeCtaTitle}</Link></p>
                  </div>
               }
            </>
         )
      }}
   </Query>
  )
}

DadJokeOfTheDay.defaultProps = {
   mobile: false,
}

DadJokeOfTheDay.propTypes = {
   mobile: bool,
}

export default DadJokeOfTheDay